import { createAction } from 'typesafe-actions';
import {
  TaskListItem,
  TaskDueGroup,
  TasksAssignedFilter,
  TasksAssignedFilterOptions,
  TaskDetailsResponse,
  TaskPagination,
} from 'types/Tasks';
import type { FileBeingAdded } from 'service/file/types';

export const doTasksAssignedLoad = createAction('@TASKS_ASSIGNED/LOAD')<{
  showBlockingLoader?: boolean;
  filter?: Partial<TasksAssignedFilter>;
  page?: number;
}>();

export const doTasksAssignedLoadSuccess = createAction(
  '@TASKS_ASSIGNED/LOAD_SUCCESS',
)<{
  tasks: TaskListItem[];
  dueGroups: TaskDueGroup[];
  pagination: TaskPagination;
  append: boolean;
}>();

export const doTasksAssignedLoadFailure = createAction(
  '@TASKS_ASSIGNED/LOAD_FAILURE',
)<{
  error?: string;
}>();

export const doTasksAssignedSetFilter = createAction(
  '@TASKS_ASSIGNED/SET_FILTER',
)<TasksAssignedFilter>();

export const doTasksAssignedFilterOptionsLoad = createAction(
  '@TASKS_ASSIGNED/FILTER_OPTIONS_LOAD',
)<{
  loadTasksOnSuccess?: boolean;
  organisationIds?: string[];
  showError?: boolean;
  showBlockingLoader?: boolean;
  draft?: boolean;
}>();

export const doTasksAssignedFilterOptionsLoadSuccess = createAction(
  '@TASKS_ASSIGNED/FILTER_OPTIONS_LOAD_SUCCESS',
)<{
  filterOptions: TasksAssignedFilterOptions;
  draft?: boolean;
}>();

export const doTasksAssignedClearDraftFilterOptions = createAction(
  '@TASKS_ASSIGNED/CLEAR_DRAFT_FILTER_OPTIONS',
)();

export const doTasksAssignedFilterOptionsLoadFailure = createAction(
  '@TASKS_ASSIGNED/FILTER_OPTIONS_LOAD_FAILURE',
)<{
  error: Error;
}>();

export const doTasksAssignedFilterOpenModal = createAction(
  '@TASKS_ASSIGNED/FILTER_OPEN_MODAL',
)();
export const doTasksAssignedDetailsLoad = createAction(
  '@TASKS_ASSIGNED/DETAILS_LOAD',
)<{
  taskId: string;
}>();

export const doTasksAssignedDetailsClose = createAction(
  '@TASKS_ASSIGNED/DETAILS_CLOSE',
)();

export const doTaskAssignedDetailsLoadSuccess = createAction(
  '@TASKS_ASSIGNED/DETAILS_LOAD_SUCCESS',
)<{
  task: TaskDetailsResponse;
}>();

export const doTaskAssignedDetailsLoadFailure = createAction(
  '@TASKS_ASSIGNED/DETAILS_LOAD_FAILURE',
)<{
  error: string | null;
}>();

export const doTaskAssignedStatusSave = createAction(
  '@TASKS_ASSIGNED/STATUS_SAVE',
)<{
  taskId: TaskDetailsResponse['id'];
  status: TaskDetailsResponse['activeStatus'];
}>();

export const doTaskAssignedStatusSaveSuccess = createAction(
  '@TASKS_ASSIGNED/STATUS_SAVE_SUCCESS',
)<{
  taskId: TaskDetailsResponse['id'];
  status: TaskDetailsResponse['activeStatus'];
  statusChangeComment: TaskDetailsResponse['comments'][number] | null;
}>();

export const doTaskAssignedCommentCreate = createAction(
  '@TASKS_ASSIGNED/COMMENT_CREATE',
)<{
  taskId: TaskDetailsResponse['id'];
  composerId: string;
  submissionId: string;
  comment: string;
  uploadIds: string[];
}>();

export const doTaskAssignedCommentCreateSuccess = createAction(
  '@TASKS_ASSIGNED/COMMENT_CREATE_SUCCESS',
)<{
  taskId: TaskDetailsResponse['id'];
  composerId: string;
  submissionId: string;
  comment: TaskDetailsResponse['comments'][number];
}>();

export const doTaskAssignedCommentCreateFailure = createAction(
  '@TASKS_ASSIGNED/COMMENT_CREATE_FAILURE',
)<{
  taskId: TaskDetailsResponse['id'];
  composerId: string;
  submissionId: string;
}>();

export const doTaskAssignedCommentDraftAttachmentUpload = createAction(
  '@TASKS_ASSIGNED/COMMENT_DRAFT_ATTACHMENT_UPLOAD',
)<{
  taskId: TaskDetailsResponse['id'];
  uploadId: string;
  file: FileBeingAdded;
}>();
